import React from "react";
import Content from "./content";

const ContentDataContainer = (props) => {
  let repLocators = props.data?.getRepLocators;
  return <Content repLocators={repLocators} />;
};
export default ContentDataContainer;
